import { LinkButton, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAdvantagesItemClick, trackNewbuildingLinkClick } from './tracking';
import { Advantages } from '../../components/Advantages';
import { Content, FullscreenPopup, Header } from '../../components/Advantages/components/FullscreenPopup';
import { NewbuildingAdvantagesContainer } from '../../components/NewbuildingAdvantages/NewbuildingAdvantagesContainer';
import {
  getGaLabel,
  getNewbuildingAdvantages,
  getNewbuildingLink,
  getNewbuildingName,
} from '../../selectors/newObject';
import { IAdvantage } from '../../types/newobject/newbuildingAdvantages';
import { NewbuildingSpecifications } from '../NewbuildingSpecifications/NewbuildingSpecifications';

const NewbuildingAdvantages = () => {
  const name = useSelector(getNewbuildingName);
  const advantages: IAdvantage[] = useSelector(getNewbuildingAdvantages);
  const newbuildingLink = useSelector(getNewbuildingLink);
  const gaLabel = useSelector(getGaLabel);

  const [isOpened, setOpenedState] = React.useState(false);
  const [advantageIndex, setAdvantageIndex] = React.useState(0);

  const onItemClick = React.useCallback(
    (i: number) => {
      setAdvantageIndex(i);
      setOpenedState(true);

      const item = advantages[i];
      if (item) {
        trackAdvantagesItemClick(item.advantageType);
      }
    },
    [setOpenedState, setAdvantageIndex, advantages, trackAdvantagesItemClick],
  );

  const onNewbuildingLinkClick = React.useCallback(
    () => trackNewbuildingLinkClick(gaLabel),
    [trackNewbuildingLinkClick, gaLabel],
  );

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (!advantages || advantages.length === 0) {
    return null;
  }

  const advantage = advantages[advantageIndex];

  return (
    <NewbuildingAdvantagesContainer name={name}>
      <NewbuildingSpecifications />
      <Advantages advantages={advantages} onItemClick={onItemClick} />
      <FullscreenPopup
        isOpened={isOpened}
        header={<Header onClose={onClose} title={<UIText1>ЖК «{name}»</UIText1>} />}
        onClose={onClose}
        content={<Content {...advantage} />}
      />

      <LinkButton
        target="_blank"
        href={newbuildingLink}
        size="XS"
        theme="stroke_primary"
        onClick={onNewbuildingLinkClick}
      >
        Подробнее о жилом комплексе
      </LinkButton>
    </NewbuildingAdvantagesContainer>
  );
};

// eslint-disable-next-line import/no-default-export
export default NewbuildingAdvantages;
